import { sliderProducts } from '../sliders/slider-products.js';

/**
 * Get the recommended products for the product page
 * 
 * @return {void} 
 */
function getRelatedProducts() {
	const $section = $('.js-section-related');
	const $grid = $('.js-grid-related');

	if ($grid.length == 0) {
		return
	}

	const { productId, baseUrl, limit } = $grid[0].dataset;

	const requestUrl = `${baseUrl}?section_id=product-recommendations&product_id=${productId}&limit=${limit}`;
	
	$.ajax({
		url: requestUrl,
		type: 'GET',
	})
	.done(function(response) {
		const products = $(response).find('.js-grid-related').html();

		if (products == '') {
			return
		}

		// Append the recommended products and init the slider
		$grid.html(products);
		$section.addClass('section--visible');
		sliderProducts()
	})
	.fail(function() {
		console.log("error");
	})
};

getRelatedProducts();